import { store, store$ } from '@redux/store';
import { searchParametersActions } from 'features/searchResultsFacets';
import { map, filter, distinctUntilChanged } from 'rxjs';
import { selectAppliedFacets } from '../redux/selectors';

export default class ClearFilters {
  constructor(buttonElement) {
    
    buttonElement.addEventListener('click', () => {
      store.dispatch(searchParametersActions.clearFilters());
    });
    
    this.onFacetsApplied$ = store$.pipe(map(selectAppliedFacets), filter(Boolean), distinctUntilChanged());
  }
}
